import React from "react";
import arrowDown from "../../../assets/img/arrow_down.svg";
import empty_establishment from "../../../assets/img/empty_establishment.svg";
import ProductImg from "../../../assets/img/empty_product.svg";
import { Switch, withStyles } from "@material-ui/core";
import NumberFormat from "react-number-format";

export function List(props) {
  let pages = [];
  let qtPages = Math.ceil(parseInt(props.page) + 5);
  let pagesList = Math.ceil(parseInt(props.totalItem) / parseInt(props.limit));

  let pageMin = 1;
  if (parseInt(props.page) > 5) {
    pageMin = parseInt(props.page) - 5;
  }
  if (qtPages > pagesList) {
    qtPages = pagesList;
  }
  for (let count = pageMin; count < qtPages + 1; count++) {
    pages.push(count);
  }
  // let pages = [];
  // let qtPages = Math.ceil(props.totalItem / props.limit);
  // for (let count = 1; count < qtPages + 1; count++) {
  //   pages.push(count);
  // }
  return (
    <div className="row m-0 w-100">
      <div
        className={`list-body col-12 col-lg px-0 overflow-hidden ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.children}
      </div>
      <div className="col-12 px-0 d-block d-lg-flex justify-content-between mt-3 m-0 align-items-center">
        <form className="border-auro-metal w-auto br-5">
          <select
            aria-expanded="true"
            onChange={props.onChange}
            value={props.limit}
            className="c-pointer form-select form-select-lg border-0 fz-14 box-shadow-none text-cl-auroMetal ff-univanova-regular notification-scroll"
          >
            <option value="10">Mostrar 10 {props.section}</option>
            <option value="20">Mostrar 20 {props.section}</option>
            <option value="30">Mostrar 30 {props.section}</option>
          </select>
        </form>
        <div className="mt-3 mt-lg-0 d-flex justify-content-around justify-content-lg-between">
          {pages.length > 0 && (
            <span
              onClick={props.prevButton}
              className="text-cl-auroMetal ff-univanova-bold fz-14 t-decoration-none c-pointer"
            >
              Anterior
            </span>
          )}
          {pages.map((item, index) => (
            <span
              key={index}
              onClick={props.changePage}
              id={item}
              className={`${
                props.page === item ? "text-cl-blue" : "text-cl-auroMetal"
              } ff-univanova-bold fz-14 t-decoration-none c-pointer mx-2`}
            >
              {item}
            </span>
          ))}
          {pages.length > 0 && (
            <span
              onClick={props.nextButton}
              className="text-cl-auroMetal ff-univanova-bold fz-14 t-decoration-none ms-2 c-pointer"
            >
              Próximo
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export function ListHeader(props) {
  return (
    <div
      className={`row m-0 ps-2 py-2 d-none d-lg-flex ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      {props.children}
    </div>
  );
}

export function ListHeaderItem(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <span className={`ff-univanova-600 fz-16 ${props.filter ? "text-cl-azure" : ""}`}>{props.title}</span>
        {props.children}
      </div>
    </>
  );
}

export function ListHeaderItemDateRage(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <span className=" ff-univanova-600 fz-16">{props.title}</span>
        {props.children}
      </div>
    </>
  );
}

export function ListHeaderItemDropdownDateRage(props) {
  return (
    <>
      <button
        type="button"
        className="btn btn-secondary dropdown-toggle dropdown-toggle-split p-0 box-shadow-none"
        id="dropdownSearchBox"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-reference="parent"
      >
        <img className="arrow ms-2" src={arrowDown} width={24} height={24} alt="" />
      </button>

      <ul
        style={{
          transform: "translate3d(-350px, 186px, 0px)",
        }}
        id="daterage"
        className="dropdown-menu"
      >
        {props.children}
      </ul>
    </>
  );
}

export function ListHeaderItemDropdown(props) {
  return (
    <>
      <button
        type="button"
        className="btn btn-secondary dropdown-toggle dropdown-toggle-split p-0 box-shadow-none"
        id="dropdownSearchBox"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-reference="parent"
      >
        <img className="arrow ms-2" src={arrowDown} width={24} height={24} alt="" />
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownSearchBox" style={{ borderRadius: "0px" }}>
        {props.children}
      </ul>
    </>
  );
}

export function ListBody(props) {
  return (
    <>
      <div className="w-100 list-body-border">{props.children}</div>
    </>
  );
}

export function ListBodyCell(props) {
  return (
    <>
      {(props.link !== undefined) & (props.link !== "") ? (
        <a href={props.link} onClick={props.function} className={`t-decoration-none`}>
          <div
            className={`row m-0 ps-2 py-2 cell-list py-3 ${props.hover} ${
              (props.className !== undefined) & (props.className !== null) ? props.className : ""
            }`}
          >
            {props.children}
          </div>
        </a>
      ) : (
        <div
          className={`row m-0 ps-2 py-4 ${props.hover} ${
            (props.className !== undefined) & (props.className !== null) ? props.className : ""
          }`}
        >
          {props.children}
        </div>
      )}
    </>
  );
}

export function ListBodyItem(props) {
  return (
    <>
      <div
        onClick={props.onClick}
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.description !== "" ? (
          <span className="font-poppins fw-bold text-prop-grey-light fz-12 d-flex d-lg-none me-1">
            {props.description}:
          </span>
        ) : (
          <></>
        )}
        <span className={` ff-univanova-regular fz-14 ${props.textColor}`}>{props.title}</span>
        {props.children && props.children}
      </div>
    </>
  );
}

export function ListBodyItemWithImage(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <div
          className="d-flex justify-content-center align-items-center overflow-hidden item-img me-2 bg-white"
          style={{ maxWidth: "48px", height: "48px" }}
        >
          <img className="" src={props.img === "" ? empty_establishment : props.img} alt="" width={65} />
        </div>
        <span className=" ff-univanova-regular fz-14">{props.title}</span>
      </div>
    </>
  );
}

export function ListBodyItemAction(props) {
  return (
    <div
      className={`col-12 col-lg-${props.sizeLg} ms-auto d-flex align-items-center justify-content-end ${props.margin}`}
    >
      <div className="btn-group">
        <button type="button" className="btn dropdown-toggle py-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="bi bi-three-dots-vertical"></i>
        </button>
        <ul
          className="dropdown-menu"
          style={{
            borderRadius: "10px",
            padding: "0px",
            margin: "0px",
            minWidth: "auto",
          }}
        >
          {props.children}
        </ul>
      </div>
    </div>
  );
}

export function ListBodyItemActionPreference(props) {
  return (
    <div className={`col-lg-${props.sizeLg} d-flex align-items-center ${props.margin}`}>
      <div className="btn-group dropstart">
        <button type="button" className="btn  py-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="bi bi-three-dots-vertical"></i>
        </button>
        <ul
          className="dropdown-menu insert-none b-r-10"
          style={{
            borderRadius: "10px !important",
            padding: "0px",
            margin: "0px",
            minWidth: "auto",
          }}
        >
          {props.children}
        </ul>
      </div>
    </div>
  );
}

export function ListBodyItemLink(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.description !== "" ? (
          <span className="font-poppins fw-bold text-prop-grey-light fz-12 d-flex d-lg-none me-1">
            {props.description}:
          </span>
        ) : (
          <></>
        )}
        <a target={"_blank"} className="link ff-univanova-regular fz-14 c-pointer" href={props.link} rel="noreferrer">
          {props.title}
        </a>
      </div>
    </>
  );
}

export function ListBodyItemShowModal(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.description !== "" ? (
          <span className="font-poppins fw-bold text-prop-grey-light fz-12 d-flex d-lg-none me-1">
            {props.description}:
          </span>
        ) : (
          <></>
        )}
        <button
          onClick={props.onClick}
          className="a-button ff-univanova-regular fz-14"
          data-bs-toggle="modal"
          data-bs-target={props.modalId}
          type="button"
        >
          {props.title}
        </button>
      </div>
    </>
  );
}

export function ListBodyItemStatus(props) {
  return (
    <>
      <div className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} `}>
        {props.description !== "" ? (
          <span className="font-poppins fw-bold text-prop-grey-light fz-12 d-flex d-lg-none me-1">
            {props.description}:
          </span>
        ) : (
          <></>
        )}
        <span className={` ff-univanova-regular fz-16 br-11 px-2 ${props.className}`}>{props.title}</span>
      </div>
    </>
  );
}

export function ListBodyItemSwitch(props) {
  const CustomSwitch = withStyles({
    switchBase: {
      color: "#8c8e98",
      track: {
        backgroundColor: "#c2c2c2",
      },
      "&$checked": {
        color: "#4C9E70",
      },
      "&$checked + $track": {
        backgroundColor: "#9EC7B0",
        boxShadow: "0px 3px 6px #00000029",
      },
    },
    checked: {},
    track: { boxShadow: "0px 3px 6px #00000029" },
  })(Switch);

  return (
    <>
      <div
        onClick={props.onClick}
        onChange={props.onChange}
        name={props.name}
        className={`d-flex align-items-center justify-content-end justify-content-lg-start col-${
          props.size === undefined ? "12" : props.size
        } col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <CustomSwitch checked={props.value} />
        {props.paymentApp ? <span className="col-12 text-nowrap">{props.paymentApp}</span> : <></>}
      </div>
    </>
  );
}

export function ListBodyItemImage(props) {
  return (
    <>
      <div
        style={{ margin: "-10px 0" }}
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <div
          className="d-flex justify-content-center align-items-center overflow-hidden item-img me-2 bg-white"
          style={{ height: "68px", width: "68px" }}
        >
          <img
            className=""
            src={
              props.title[0]?.url === "" || props.title[0]?.url === undefined || props.title[0]?.url === null
                ? ProductImg
                : props.title[0]?.url
            }
            height={78}
          />
        </div>
      </div>
    </>
  );
}

export function ListBodyItemSelect(props) {
  return (
    <div className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} `}>
      <select
        disabled={props.disabled}
        onChange={props.onChange}
        aria-expanded="true"
        value={props.value}
        style={{
          backgroundColor: "inherit",
        }}
        className={`${
          props.disabled ? "border-cl-american-silver" : "c-pointer border-cl-auroMetal"
        }  form-select border-0 rounded-0 border-bottom  form-select-lg px-1 fz-14 box-shadow-none ff-univanova-regular notification-scroll ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.children}
      </select>
    </div>
  );
}

export function ListBodyItemNumberformat(props) {
  return (
    <>
      <div
        onClick={props.onClick}
        className={`d-flex align-items-center col-12 col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        {props.description !== "" ? (
          <span className="font-poppins fw-bold text-prop-grey-light fz-12 d-flex d-lg-none me-1">
            {props.description}:
          </span>
        ) : (
          <></>
        )}
        {props.empty ? (
          <span className="d-flex flex-row flex-lg-column ff-univanova-regular fz-14 ">N/A</span>
        ) : (
          <span className={`d-flex flex-row flex-lg-column ff-univanova-regular fz-14 ${props.textColor}`}>
            {props.value ? (
              <NumberFormat
                thousandSeparator={"."}
                decimalSeparator=","
                displayType={"text"}
                prefix={"R$ "}
                suffix={Number.isInteger(props.value) ? ",00" : ""}
                value={props.value}
                decimalScale={2}
              />
            ) : (
              "N/A"
            )}
            <span className={`text-cl-black ms-1 ms-lg-0 ${props.avgValue === true ? "d-flex" : "d-none"}`}>
              {"(valor médio)"}
            </span>
          </span>
        )}
      </div>
    </>
  );
}
